import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    updateVeridasUser
} from '../../../reduxToolkit/Visitor/VisitorApi';
import { toast } from 'react-toastify';
import HandleChange from '../../../Helpers/HandleChange';
import {getUrlParameters, TAB_INDEX} from '../../Dashboard/Visitor/External/Model/Model';
import routes from '../../../Routes/routes';
import { MODEL_VERIDAS } from '../Model/Models';
import { getDateFormat } from '../../../Apis/functions';
import useHandleBeforeUnload from './useHandleBeforeUnload';
import useBackNavigation from './useBackNavigation';
import {GetInvitationById} from "../../../reduxToolkit/Invitation/InvitationApi";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const SuccessValidationFormApp = () => {

    const { id, guardFlowId } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userDataSuccess = useSelector((state) => state.VisitorSlice.userDataDocument);
    const validationData = useSelector((state) => state.VisitorSlice.getValidationId);
    const { getInvitationById } = useSelector((state) => state.InvitationSlice);

    const [requestCompleted, setRequestCompleted] = useState(false);
    const [modifiedData, setModifiedData] = useState({ ...MODEL_VERIDAS });
    const [loading, setLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(1);
    const { handleChange } = HandleChange({ model: modifiedData, setModel: setModifiedData });

    /**
     * Effect to set the data.
     */
    useEffect(() => {
        if (userDataSuccess) {
            setModifiedData(setData(userDataSuccess))
        }
    }, [userDataSuccess]);

    /**
     * Function that sets data and returns a model.
     * @param userDataSuccess
     */
    const setData = (userDataSuccess) => {
        return {
            name: userDataSuccess?.name || '',
            lastName: userDataSuccess?.lastName || '',
            secondLastName: userDataSuccess?.secondLastName || '',
            dob: userDataSuccess?.dob ? getDateFormat(userDataSuccess.dob, false) : null,
            gender: userDataSuccess?.gender || null,
            documentId: userDataSuccess?.documentId || '',
        }
    }

    /**
     * Function to update data and validate the data obtained from the API.
     */
    const handleSubmit = () => {
        if (activeStep == TAB_INDEX.TWO) {
            navigate(getUrlParameters({url: routes.invitationDetails.invitation, id: getInvitationById?.invitation?.id, guardFlowId}));
            return;
        }
        setActiveStep(2);
        setLoading(true);
        if (JSON.stringify(modifiedData) !== JSON.stringify(userDataSuccess)) {
            const payload = {
                userId: getInvitationById?.invitation?.visitorId,
                validationId: validationData,
                ocrAndScoresResponse: {
                    ...modifiedData,
                    dob: new Date(modifiedData.dob).getTime(),
                },
            };

            dispatch(updateVeridasUser(payload)).then(({ payload: { data: { code, success } } }) => {
                handleResponse(code, success);
            });
        } else {
            dispatch(
                updateVeridasUser({
                    userId: getInvitationById?.invitation?.visitorId,
                    validationId: validationData,
                    ocrAndScoresResponse: userDataSuccess,
                })
            ).then(({ payload: { data: { code, success } } }) => {
                handleResponse(code, success);
            });
        }
    };

    /**
     * Control of the response to the request
     * @param success
     * @param code
     */
    const handleResponse = (success, code) => {
        if (success) {
            toast.success(t('validation_successful'));
            dispatch(GetInvitationById(id)).then(({ payload:{ data:{ success }}})=>{
                if (success) navigate(getUrlParameters({ url: routes.invitationDetails.registrationProcess, id: id, guardFlowId }));
            });
        } else {
            navigate(getUrlParameters({ url: routes.veridasIntegration.validationFail, id:getInvitationById?.invitation?.id, guardFlowId }));
            toast.error(t('validation_failed') + `: ${t(`errorCode.${code}`)}`);
        }
        setLoading(false);
    }

    useBackNavigation({ getInvitationById, validationId: validationData });
    useHandleBeforeUnload({ getInvitationById , validationId: validationData});

    return {
        id,
        guardFlowId,
        t, navigate,
        dispatch,
        userDataSuccess,
        validationData,
        getInvitationById,

        requestCompleted, setRequestCompleted,
        modifiedData, setModifiedData,
        activeStep, setActiveStep,
        loading, setLoading,
        handleSubmit,
        handleChange,
    }

}

export default SuccessValidationFormApp
